<div style="max-height: 46vh; overflow-y: scroll;">
        <table #dataTable mat-table matSort [dataSource]="teamCasesByAccountData" class="mat-elevation-z1" style="overflow-y: auto;">
            <ng-container matColumnDef="selection">
                <th mat-header-cell *matHeaderCellDef style="width:55px" id="selectionHeader">
                </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="Account_Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
                <td mat-cell *matCellDef="let element">{{ element.accountName }}</td>
            </ng-container>

            <ng-container matColumnDef="Cases">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Cases</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex align-items-center" style="gap: 8px" *ngIf="element.totalCases > 0">
                        <span style="white-space: nowrap; width: 90px">{{ element.totalCases + ' assigned' }}</span>
                        <mat-chip-set>
                            <mat-chip class="circle-chip pastDue">{{ element.pastDue }}</mat-chip>
                            <mat-chip class="circle-chip dueToday">{{ element.dueToday }}</mat-chip>
                            <mat-chip class="circle-chip dueTomorrow">{{ element.dueTomorrow }}</mat-chip>
                        </mat-chip-set>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Tasks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tasks</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex align-items-center" style="gap: 8px" *ngIf="element.totalTasks > 0">
                        <span style="white-space: nowrap; width: 90px">{{ element.totalTasks + ' assigned' }}</span>
                        <mat-chip-set>
                            <mat-chip class="circle-chip pastDue">{{ element.tasksPastDue }}</mat-chip>
                            <mat-chip class="circle-chip dueToday">{{ element.tasksDueToday }}</mat-chip>
                            <mat-chip class="circle-chip dueTomorrow">{{ element.tasksDueTomorrow }}</mat-chip>
                        </mat-chip-set>
                    </div>
                </td>
            </ng-container>

    
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div *ngIf="teamCasesByAccountData.filteredData == null || teamCasesByAccountData.filteredData.length == 0" class="bg-white">
            <div class="p-4 text-center text-muted ">
                <img src="./assets/images/no-data-placeholder.png " alt=" " class="pb-3 " />
                <h6>No Cases Found</h6>
            </div>
        </div>
    </div>
    <div class="flex align-items-center">
        <div id="actionButtons" *ngIf="selection.selected.length > 0" class="flex">
            <mat-chip-set>
                <mat-chip>{{selection.selected.length}} selected</mat-chip>
            </mat-chip-set>
        </div>
        <div style="margin-left: auto">
            <mat-paginator
                #paginator
                *ngIf="teamCasesByAccountData?.data?.length > 0"
                [length]="teamCasesByAccountData?.data?.length || 0"
                [pageIndex]="0"
                [pageSize]="10"
                appearance="fill"
                [pageSizeOptions]="[10, 25, 50, 100]"
            >
            </mat-paginator>
        </div>
    </div>